export const BOOK_BUNDLES = [
  {
    slug: 'macros-made-easy-for-women',
    title: 'Macros Made Easy for Women',
    subtitle: 'Flexible eating, sustainable weight loss, and building a body you love',
    author: 'Ava Mitchell',
    category: 'Nutrition',
    image: '/images/books/macros-made-easy.jpg',
    price: 19,
    checkoutLabel: 'Digital Book + Printable PDF + App Access',
    highlights: [
      'Kindle and Apple Books compatible digital edition',
      'Printable PDF edition',
      'Free Integrative Health Journal app access included',
    ],
    description:
      'A beginner-friendly macro tracking system for women who want flexible eating, clear targets, and practical daily structure without diet extremes.',
    bestFor: 'Women who want clear macro targets without rigid dieting.',
    promise: 'Turn confusing calories, protein, carbs, and fat into a simple daily rhythm you can actually follow.',
    inside: [
      'Macro basics explained in plain language',
      'Step-by-step target setting and adjustment guidance',
      'Flexible meal-building examples for busy days',
      'Troubleshooting for hunger, cravings, plateaus, and weekends',
    ],
    tools: ['Printable macro worksheet', 'Meal planning templates', '25 app-ready recipes', 'Book-code app access'],
    outcomes: ['Know what to eat without guessing', 'Build higher-protein meals', 'Track consistently without perfectionism'],
  },
  {
    slug: 'cycle-synced-fitness-for-women',
    title: 'Cycle Synced',
    subtitle: 'A phase-by-phase guide to training, eating, and losing fat around your menstrual cycle',
    author: 'Ava Mitchell',
    category: 'Women\'s Fitness',
    image: '/images/books/cycle-synced.jpg',
    price: 17,
    checkoutLabel: 'Digital Book + Printable PDF + App Access',
    highlights: [
      'Kindle and Apple Books compatible digital edition',
      'Printable PDF edition',
      'Free Integrative Health Journal app access included',
    ],
    description:
      'A practical guide to matching nutrition, training, recovery, and fat-loss expectations to the phases of the menstrual cycle.',
    bestFor: 'Women who feel like energy, cravings, and workouts change week to week.',
    promise: 'Use your cycle as a planning tool instead of fighting the same plan every day of the month.',
    inside: [
      'Phase-by-phase nutrition and training guidance',
      'How to adjust intensity, carbs, recovery, and expectations',
      'Craving and appetite strategies for each phase',
      'Simple tracking prompts to spot personal patterns',
    ],
    tools: ['Cycle phase planner', 'Workout intensity guide', 'Nutrition adjustment checklist', 'Book-code app access'],
    outcomes: ['Plan around real energy changes', 'Reduce all-or-nothing thinking', 'Train with better recovery'],
  },
  {
    slug: 'glp1-companion-for-women-over-50',
    title: 'The GLP-1 Companion for Women Over 50',
    subtitle: 'Muscle, protein, side effects, menopause, and long-term success',
    author: 'Ava Mitchell',
    category: 'GLP-1 Support',
    image: '/images/books/glp1-companion.jpg',
    price: 17,
    checkoutLabel: 'Digital Book + Printable PDF + App Access',
    highlights: [
      'Kindle and Apple Books compatible digital edition',
      'Printable PDF edition',
      'Free Integrative Health Journal app access included',
    ],
    description:
      'A clear companion for women over 50 using GLP-1 medications, with practical support for protein, strength, side effects, and maintenance.',
    bestFor: 'Women over 50 using or considering GLP-1 support who want to protect muscle and long-term habits.',
    promise: 'Pair appetite changes with protein, strength, hydration, and maintenance routines that keep you steady.',
    inside: [
      'Protein and muscle-preservation priorities',
      'Meal structure for lower appetite days',
      'Common side-effect support habits',
      'Maintenance planning beyond the scale',
    ],
    tools: ['Protein-first meal framework', 'Symptom support checklist', 'Strength habit tracker', 'Book-code app access'],
    outcomes: ['Eat enough protein with less appetite', 'Support muscle after 50', 'Build a maintenance plan early'],
  },
  {
    slug: 'the-gut-reset',
    title: 'The Gut Reset',
    subtitle: 'A 28-day protocol to support your microbiome, reduce bloating, and reclaim energy',
    author: 'Mara Hartwell',
    category: 'Gut Health',
    image: '/images/books/the-gut-reset.png',
    price: 17,
    checkoutLabel: 'Digital Book + Printable PDF + App Access',
    highlights: [
      'Kindle and Apple Books compatible digital edition',
      'Printable PDF edition',
      'Free Integrative Health Journal app access included',
    ],
    description:
      'A structured 28-day gut health protocol with meal planning, recipes, supplement guidance, and step-by-step habit support.',
    bestFor: 'Readers who want a structured gut reset without trying random internet advice every week.',
    promise: 'Create a calmer 28-day routine around fiber, hydration, meals, sleep, and digestive-support habits.',
    inside: [
      'A four-week gut-support progression',
      'Bloating and trigger-awareness worksheets',
      'Fiber, fermented food, and hydration guidance',
      'Simple meal planning and habit routines',
    ],
    tools: ['28-day reset calendar', 'Food and symptom tracker', 'Grocery planning pages', 'Book-code app access'],
    outcomes: ['Spot digestive patterns', 'Build fiber gradually', 'Make gut-support habits easier to repeat'],
  },
  {
    slug: 'the-longevity-blueprint',
    title: 'The Longevity Blueprint',
    subtitle: 'A 12-week program to build strength, sharpen your mind, and thrive after 50',
    author: 'Clara Winslow',
    category: 'Healthy Aging',
    image: '/images/books/longevity-blueprint.png',
    price: 17,
    checkoutLabel: 'Digital Book + Printable PDF + App Access',
    highlights: [
      'Kindle and Apple Books compatible digital edition',
      'Printable PDF edition',
      'Free Integrative Health Journal app access included',
    ],
    description:
      'A 12-week healthy aging program for women over 50 focused on strength, nutrition, sleep, purpose, brain health, and resilience.',
    bestFor: 'Women over 50 who want a structured plan for strength, energy, and long-term independence.',
    promise: 'Build a practical 12-week foundation for stronger muscles, steadier routines, and healthier aging.',
    inside: [
      'Strength, protein, mobility, and recovery priorities',
      'Brain health, sleep, and stress-support routines',
      'Weekly habit focus areas for 12 weeks',
      'Progress reflection without overwhelm',
    ],
    tools: ['12-week blueprint calendar', 'Strength habit tracker', 'Sleep and recovery worksheet', 'Book-code app access'],
    outcomes: ['Build strength-focused habits', 'Support energy after 50', 'Create a weekly wellness rhythm'],
  },
  {
    slug: 'the-cortisol-reset-for-women-over-40',
    title: 'The Cortisol Reset for Women Over 40',
    subtitle: 'A science-based guide to balancing stress hormones and reclaiming energy',
    author: 'Ava Mitchell',
    category: 'Stress & Hormones',
    image: '/images/books/cortisol-reset.jpg',
    price: 17,
    checkoutLabel: 'Digital Book + Printable PDF + App Access',
    highlights: [
      'Kindle and Apple Books compatible digital edition',
      'Printable PDF edition',
      'Free Integrative Health Journal app access included',
    ],
    description:
      'A practical stress, hormone, sleep, and energy reset guide for women navigating midlife health changes.',
    bestFor: 'Women over 40 dealing with stress, poor sleep, low energy, cravings, or midlife routine disruption.',
    promise: 'Build a calmer daily structure around sleep, meals, movement, and stress recovery.',
    inside: [
      'Stress-hormone basics without fear-based advice',
      'Morning, evening, and meal-timing routines',
      'Movement and recovery recommendations for high-stress seasons',
      'Energy audit prompts and habit resets',
    ],
    tools: ['Cortisol rhythm worksheet', 'Sleep reset checklist', 'Stress inventory pages', 'Book-code app access'],
    outcomes: ['Support steadier energy', 'Improve routine consistency', 'Reduce stress-driven food chaos'],
  },
  {
    slug: 'the-waiting-muscle',
    title: 'The Waiting Muscle',
    subtitle: 'Helping kids build patience, handle screens, and grow up in an instant-gratification world',
    author: 'Elliot Hayes',
    category: 'Parenting',
    image: '/images/books/the-waiting-muscle.png',
    price: 12,
    checkoutLabel: 'Digital Book + Printable PDF',
    highlights: [
      'Kindle and Apple Books compatible digital edition',
      'Printable PDF edition',
      'Parent scripts and practical routines',
    ],
    description:
      'A parent-to-parent guide for building patience, managing screen transitions, and helping kids handle modern digital pressure.',
    bestFor: 'Parents who want calmer screen transitions, more patience, and practical scripts that work in real life.',
    promise: 'Teach waiting, frustration tolerance, and screen boundaries with repeatable family routines.',
    inside: [
      'Why patience feels harder for kids now',
      'Screen-transition scripts and routines',
      'Family rules that do not require constant arguing',
      'Practice exercises for waiting and emotional regulation',
    ],
    tools: ['Parent scripts', 'Screen transition plan', 'Family waiting challenges', 'Printable routine pages'],
    outcomes: ['Handle transitions with less conflict', 'Teach patience through practice', 'Create clearer family boundaries'],
  },
  {
    slug: 'pmp-mindset',
    title: 'PMP Mindset',
    subtitle: 'Passing the Project Management Professional exam on your first try',
    author: 'Phillip Matthews',
    category: 'Exam Prep',
    image: '/images/books/pmp-mindset.jpg',
    price: 27,
    checkoutLabel: 'Digital Book + Printable PDF',
    highlights: [
      'Kindle and Apple Books compatible digital edition',
      'Printable PDF edition',
      'Situational decision-making and Agile mindset support',
    ],
    description:
      'A practical PMP exam guide focused on situational thinking, Agile, and PMBOK 7th Edition principles.',
    bestFor: 'PMP candidates who know the material but struggle with situational exam wording.',
    promise: 'Train the decision-making mindset behind PMP questions so answer choices become clearer.',
    inside: [
      'Servant leadership and PMI mindset patterns',
      'Agile, hybrid, and predictive scenario guidance',
      'How to eliminate tempting wrong answers',
      'Exam-day thinking and review strategy',
    ],
    tools: ['Mindset checklist', 'Scenario decision rules', 'Study plan prompts', 'Printable review sheets'],
    outcomes: ['Read questions with more confidence', 'Avoid common trap answers', 'Strengthen first-try exam readiness'],
  },
];

export const getBookBundle = (slug) => BOOK_BUNDLES.find((book) => book.slug === slug);
